import { useQuery } from '@tanstack/react-query';
import { TrendingUp } from 'lucide-react';
import { apiClient } from '@/lib/api-client';
import { CardShell, EmptyState } from '../cards/card-shell';
import { formatBrl } from './format';

const ACCENT = '#10b981';

/**
 * Top 5 categorias de receita do mes corrente, com barra proporcional
 * relativa ao total da maior.
 */
export function TopCategoriasReceitaWidget() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['financial', 'stats', 'top-categories', 'income'],
    queryFn: () => apiClient.financialStatsTopCategories('income', 1, 5),
    staleTime: 1000 * 60,
  });

  const items = data ?? [];
  const max = items.reduce((acc, x) => Math.max(acc, x.total), 0) || 1;

  return (
    <CardShell title="Top categorias — Receita" icon={TrendingUp}>
      <div className="flex h-full w-full flex-col gap-2">
        {isLoading ? (
          <div className="flex flex-col gap-1.5">
            <div className="h-5 w-full animate-pulse rounded bg-[var(--surface-muted)]" />
            <div className="h-5 w-full animate-pulse rounded bg-[var(--surface-muted)]" />
            <div className="h-5 w-full animate-pulse rounded bg-[var(--surface-muted)]" />
          </div>
        ) : isError ? (
          <p className="text-xs text-[var(--fg-muted)]">
            Não foi possível carregar.
          </p>
        ) : items.length === 0 ? (
          <EmptyState
            icon={TrendingUp}
            message="Sem receitas registradas neste mês."
          />
        ) : (
          <ul className="flex w-full flex-col gap-1.5">
            {items.map((cat, idx) => {
              const pct = Math.round((cat.total / max) * 100);
              const color = cat.color || ACCENT;
              return (
                <li
                  key={cat.categoryId ?? `none-${idx}`}
                  className="flex flex-col gap-0.5 text-xs"
                >
                  <div className="flex items-center justify-between gap-2">
                    <span className="truncate text-[var(--fg)]">
                      {cat.name}
                    </span>
                    <span className="shrink-0 font-medium tabular-nums text-[var(--fg)]">
                      {formatBrl(cat.total)}
                    </span>
                  </div>
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-[var(--surface-muted)]">
                    <div
                      className="h-full rounded-full"
                      style={{
                        width: `${pct}%`,
                        background: color,
                      }}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </CardShell>
  );
}
